import {
  KpeActiveYear,
  KpePastYear,
  KpiItem,
  LastActions,
  Workers,
  ChatMessage,
  HistoryEvent,
  CardEfficiency,
  KpiFactsTableData
} from './types';

const mockChat1: ChatMessage[] = [
  {
    id: 'c1',
    author: 'Алексей Петров, Проректор',
    text:
      'План выглядит заниженным. В прошлом году было 38 млн. С учетом новых проектов предлагаю поставить минимум 45 млн',
    time: '10 мар 11:24',
    isOwn: false
  },
  {
    id: 'c2',
    author: 'Иван Иванов, Директор Физтех-школы',
    text:
      'Мы учитывали, что один контракт заканчивается в июне. Поэтому поставили более консервативный план',
    time: '10 мар 14:02',
    isOwn: true
  },
  {
    id: 'c3',
    author: 'Иван Иванов, Директор Физтех-школы',
    text:
      'Поправил значение до 42 млн. Это реалистично с учётом текущего портфеля',
    time: '10 мар 14:06',
    isOwn: true
  },
  {
    id: 'c4',
    author: 'Алексей Петров, Проректор',
    text: 'Ок, давайте тогда 43 млн, чтобы был небольшой рост',
    time: '11 мар 09:17',
    isOwn: false
  },
  {
    id: 'c5',
    author: 'Иван Иванов, Директор Физтех-школы',
    text: 'Договорились, обновил',
    time: '11 мар 09:45',
    isOwn: true
  }
];

const mockHistory1: HistoryEvent[] = [
  {
    id: 'h1',
    author: 'Иван Иванов',
    action: 'согласовал KPI',
    time: '8 мар 15:25'
  },
  {
    id: 'h2',
    author: 'Иван Иванов',
    action: 'изменил параметр на 42',
    time: '10 мар 14:06'
  },
  {
    id: 'h3',
    author: 'Иван Иванов',
    action: 'изменил параметр на 43',
    time: '11 мар 09:45'
  },
  {
    id: 'h4',
    author: 'Алексей Петров',
    action: 'согласовал KPI',
    time: '11 мар 10:03',
    isNew: true
  },
  {
    id: 'h5',
    author: 'Иван Иванов',
    action: 'согласовал KPI',
    time: '11 мар 10:49',
    isNew: true
  }
];

export const mockKpiItems: KpiItem[] = [
  {
    id: '1',
    name:
      'Удовлетворённость коллектива университета работой структурных подразделений УИТ',
    unit: 'балл',
    weight: 0.25,
    department: 'Служба внутреннего контроля и аудита',
    years: [
      { year: 2025, plan: 9, fact: 9 },
      { year: 2026, plan: 9, fact: null }
    ],
    hasNewHistory: true,
    chat: mockChat1,
    history: mockHistory1
  },
  {
    id: '2',
    name:
      'Доля своевременно реализованных проектов от запланированных в соответствии с утверждённым планом',
    unit: '%',
    weight: 0.25,
    department: 'Служба внутреннего контроля и аудита',
    years: [
      { year: 2025, plan: null, fact: null },
      { year: 2026, plan: 80, fact: null }
    ]
  },
  {
    id: '3',
    name:
      'Количество внедрённых ИИ-решений в процессы университета в рамках обеспечения ИТ-сервисов',
    unit: 'ед.',
    weight: 0.25,
    department: 'Служба внутреннего контроля и аудита',
    years: [
      { year: 2025, plan: null, fact: null },
      { year: 2026, plan: 1, fact: null }
    ]
  },
  {
    id: '4',
    name:
      'Время простоев аппаратных систем: сеть, Wi-Fi, вычислительный кластер, система хранения',
    unit: 'мин./год',
    weight: 0.25,
    department: 'УИТ',
    years: [
      { year: 2025, plan: null, fact: null },
      { year: 2026, plan: 260, fact: null }
    ]
  }
];

export const mockActiveYear: KpeActiveYear = {
  year: 2027,
  description:
    'Спланируйте свои показатели на будущий 2027 год и добейтесь лучших результатов!',
  deadlines: [
    { date: '1 марта', label: 'Старт кампании' },
    { date: '10 марта', label: 'Дедлайн заполнения KPI' },
    { date: '15 марта', label: 'Согласование с ВР' },
    { date: '25 марта', label: 'Дедлайн на апелляцию' },
    { date: '30 апреля', label: 'Передача документов на выплату премий' }
  ]
};

export const mockPastYears: KpePastYear[] = [
  {
    year: 2026,
    overallEfficiency: 65,
    indicatorsEfficiency: { current: 4, total: 7 },
    hasPremium: false
  },
  {
    year: 2025,
    overallEfficiency: 89,
    indicatorsEfficiency: { current: 6, total: 7 },
    hasPremium: true
  },
  {
    year: 2024,
    overallEfficiency: 79,
    indicatorsEfficiency: { current: 3, total: 4 },
    hasPremium: false
  }
];

export const mockLastActions: LastActions[] = [
  {
    userName: 'Алексей Петров',
    description: 'добавил новый KPI «Средний балл ЕГЭ»',
    timeLabel: 'вчера, 14:22'
  },
  {
    userName: 'Иван Иванов',
    description: 'оставил комментарий к KPI «Доходы от НИОКР»',
    timeLabel: 'вчера, 14:22'
  },
  {
    userName: 'Алексей Петров',
    description: 'согласовал KPI «Контингент студентов»',
    timeLabel: 'вчера, 14:22'
  }
];

export const mockWorkersList: Workers[] = [
  {
    userName: 'Петров П.Т',
    JobTitle: 'Название должности',
    statusName: 'Предложения по КПЭ не сформированы',
    status: 'error'
  },
  {
    userName: 'Иванов П.Т',
    JobTitle: 'Название должности',
    statusName: 'Утвержден приказ по КПЭ в 1С:ДО',
    status: 'success'
  },
  {
    userName: 'Алексеев П.Т',
    JobTitle: 'Название должности',
    statusName: 'КПЭ на согласовании в системе',
    status: 'info'
  }
];

export const mockCardEfficiencyList: CardEfficiency[] = [
  {
    character: '13%',
    title: 'Уровень эффективности',
    content:
      'Интегральный уровень эффективности считается исходя из план-факта по КПЭ и их весов',
    statusName: 'Изменено по приказу',
    status: 'info'
  },
  {
    character: '1',
    title: 'оклад в премии',
    content:
      'Размер премии зависит от уровня выполнения КПЭ: при достижении 70–99% выплачивается 1 оклад, при 100% — 3 оклада. При уровне ниже 70% премия не предусмотрена.'
  }
];

export const mockKpiFacts: KpiItem[] = [
  {
    id: '1',
    name:
      'Удовлетворённость коллектива университета работой структурных подразделений УИТ',
    unit: 'балл',
    weight: 0.25,
    department: 'Служба внутреннего контроля и аудита',
    years: [
      { year: 2025, plan: 9, fact6months: 9, fact9months: 9, fact: 9 },
      { year: 2026, plan: 9, fact6months: 9, fact9months: 9, fact: 9 }
    ],
    hasNewHistory: true,
    chat: mockChat1,
    history: mockHistory1
  },
  {
    id: '2',
    name:
      'Доля своевременно реализованных проектов от запланированных в соответствии с утверждённым планом',
    unit: '%',
    weight: 0.25,
    department: 'Служба внутреннего контроля и аудита',
    years: [
      { year: 2025, plan: null, fact6months: 9, fact9months: 9, fact: 9 },
      { year: 2026, plan: 80, fact6months: 9, fact9months: 9, fact: 9 }
    ]
  },
  {
    id: '3',
    name:
      'Количество внедрённых ИИ-решений в процессы университета в рамках обеспечения ИТ-сервисов',
    unit: 'ед.',
    weight: 0.25,
    department: 'Служба внутреннего контроля и аудита',
    years: [
      { year: 2025, plan: null, fact6months: 9, fact9months: 9, fact: 9 },
      { year: 2026, plan: 1, fact6months: 9, fact9months: 9, fact: 9 }
    ]
  },
  {
    id: '4',
    name:
      'Время простоев аппаратных систем: сеть, Wi-Fi, вычислительный кластер, система хранения',
    unit: 'мин./год',
    weight: 0.25,
    department: 'УИТ',
    years: [
      { year: 2025, plan: null, fact6months: 9, fact9months: 9, fact: 9 },
      { year: 2026, plan: 260, fact6months: 9, fact9months: 9, fact: 9 }
    ]
  }
];

export const mockKpiFactsTables: KpiFactsTableData[] = [
  {
    kpiId: '1',
    kpiName: 'Оценка деятельности департамента обучающимися',
    unit: 'балл',
    year: 2026,
    responsibles: [
      {
        id: '1',
        fullName: 'Иванов П.Т',
        position: 'Название должности',
        plan: 75,
        hasAppeal: true,
        facts: [
          { period: '6months', value: 62, isEditable: true },
          { period: '9months', value: 68, isEditable: true },
          { period: '12months', value: null, isEditable: false }
        ]
      },
      {
        id: '2',
        fullName: 'Иванов П.Т',
        position: 'Название должности',
        plan: 70,
        facts: [
          { period: '6months', value: 55, isEditable: true },
          { period: '9months', value: 64, isEditable: true },
          { period: '12months', value: 73, isEditable: false }
        ]
      }
    ]
  },

  {
    kpiId: '2',
    kpiName:
      'Доля выпускников программ подготовки научных и научно-педагогических кадров в аспирантуре МФТИ, защитивших кандидатские диссертации в год выпуска и ранее, к количеству аспирантов выпускных курсов',
    unit: '%',
    year: 2026,
    responsibles: [
      {
        id: '3',
        fullName: 'Иванов П.Т',
        position: 'Название должности',
        plan: 45,
        facts: [
          { period: '6months', value: 38, isEditable: true },
          { period: '9months', value: 42, isEditable: true },
          { period: '12months', value: null, isEditable: false }
        ]
      },
      {
        id: '4',
        fullName: 'Иванов П.Т',
        position: 'Название должности',
        plan: 50,
        facts: [
          { period: '6months', value: 47, isEditable: true },
          { period: '9months', value: null, isEditable: true },
          { period: '12months', value: null, isEditable: false }
        ]
      }
    ]
  },

  {
    kpiId: '3',
    kpiName:
      'Численность лиц, прошедших обучение по дополнительным профессиональным программам',
    unit: 'чел.',
    year: 2026,
    responsibles: [
      {
        id: '5',
        fullName: 'Иванов П.Т',
        position: 'Название должности',
        plan: 12,
        facts: [
          { period: '6months', value: 5, isEditable: true },
          { period: '9months', value: 9, isEditable: true },
          { period: '12months', value: null, isEditable: false }
        ]
      },
      {
        id: '6',
        fullName: 'Иванов П.Т',
        position: 'Название должности',
        plan: 8,
        facts: [
          { period: '6months', value: 4, isEditable: true },
          { period: '9months', value: 6, isEditable: true },
          { period: '12months', value: 7, isEditable: false }
        ]
      }
    ]
  }
];
